let cathedralCoords = [{ lat: 52.63423, lng: 1.30531 }, { lat: 52.63429, lng: 1.3059 }, { lat: 52.63434, lng: 1.30653 }, { lat: 52.63437, lng: 1.30714 }, { lat: 52.6344, lng: 1.30775 }, { lat: 52.6344, lng: 1.30798 }, {
  lat: 52.6344,
  lng: 1.30798
}, { lat: 52.63439, lng: 1.30819 }, { lat: 52.63439, lng: 1.30819 }, { lat: 52.63439, lng: 1.30819 }, { lat: 52.63434, lng: 1.30842 }, { lat: 52.63434, lng: 1.30842 }, { lat: 52.63425, lng: 1.30859 }, {
  lat: 52.63425,
  lng: 1.30859
}, { lat: 52.63419, lng: 1.30875 }, { lat: 52.63415, lng: 1.30888 }, { lat: 52.63407, lng: 1.30893 }, { lat: 52.63401, lng: 1.30896 }, { lat: 52.63391, lng: 1.30901 }, { lat: 52.63382, lng: 1.30903 }, {
  lat: 52.63363,
  lng: 1.30909
}, { lat: 52.63356, lng: 1.30914 }, { lat: 52.63348, lng: 1.30913 }, { lat: 52.63342, lng: 1.30914 }, { lat: 52.63333, lng: 1.30915 }, { lat: 52.63321, lng: 1.30915 }, { lat: 52.63311, lng: 1.30914 }, {
  lat: 52.63302,
  lng: 1.30912
}, { lat: 52.63287, lng: 1.30906 }, { lat: 52.63271, lng: 1.30898 }, { lat: 52.6326, lng: 1.30889 }, { lat: 52.63251, lng: 1.30883 }, { lat: 52.6324, lng: 1.30875 }, { lat: 52.63237, lng: 1.30877 }, {
  lat: 52.63228,
  lng: 1.30871
}, { lat: 52.6322, lng: 1.30868 }, { lat: 52.63217, lng: 1.30865 }, { lat: 52.6321, lng: 1.30859 }, { lat: 52.63205, lng: 1.30857 }, { lat: 52.63198, lng: 1.30856 }, { lat: 52.63193, lng: 1.30855 }, {
  lat: 52.63178,
  lng: 1.30846
}, { lat: 52.63169, lng: 1.30844 }, { lat: 52.63162, lng: 1.30839 }, { lat: 52.63152, lng: 1.30838 }, { lat: 52.63141, lng: 1.30837 }, { lat: 52.63141, lng: 1.30837 }, { lat: 52.63141, lng: 1.30837 }, {
  lat: 52.63141,
  lng: 1.30837
}, { lat: 52.63141, lng: 1.30837 }, { lat: 52.63141, lng: 1.30837 }, { lat: 52.63141, lng: 1.30837 }, { lat: 52.63141, lng: 1.30837 }, { lat: 52.63141, lng: 1.30837 }, { lat: 52.63141, lng: 1.30837 }, {
  lat: 52.63141,
  lng: 1.30837
}, { lat: 52.63141, lng: 1.30837 }, { lat: 52.63141, lng: 1.30837 }, { lat: 52.63141, lng: 1.30837 }, { lat: 52.63141, lng: 1.30837 }, { lat: 52.63141, lng: 1.30837 }, { lat: 52.63141, lng: 1.30837 }, {
  lat: 52.63141,
  lng: 1.30837
}, { lat: 52.63141, lng: 1.30837 }, { lat: 52.63141, lng: 1.30837 }, { lat: 52.63141, lng: 1.30837 }, { lat: 52.63141, lng: 1.30837 }, { lat: 52.63141, lng: 1.30837 }, { lat: 52.63141, lng: 1.30837 }, {
  lat: 52.6313,
  lng: 1.30828
}, { lat: 52.63115, lng: 1.30822 }, { lat: 52.63073, lng: 1.308 }, { lat: 52.63066, lng: 1.30797 }, { lat: 52.63035, lng: 1.30779 }, { lat: 52.63002, lng: 1.30756 }, { lat: 52.62976, lng: 1.30735 }, {
  lat: 52.62953,
  lng: 1.30718
}, { lat: 52.62942, lng: 1.3071 }, { lat: 52.62931, lng: 1.30702 }, { lat: 52.62922, lng: 1.30694 }, { lat: 52.62903, lng: 1.30679 }, { lat: 52.62888, lng: 1.30667 }, { lat: 52.62869, lng: 1.30652 }, {
  lat: 52.62849,
  lng: 1.30637
}, { lat: 52.62833, lng: 1.30624 }, { lat: 52.62811, lng: 1.30604 }, { lat: 52.62801, lng: 1.30596 }, { lat: 52.62795, lng: 1.3059 }, { lat: 52.62789, lng: 1.30588 }, { lat: 52.62797, lng: 1.30563 }, {
  lat: 52.62825,
  lng: 1.30475
}, { lat: 52.62849, lng: 1.30408 }, { lat: 52.62883, lng: 1.30311 }, { lat: 52.62916, lng: 1.30218 }, { lat: 52.62932, lng: 1.30167 }, { lat: 52.62943, lng: 1.30122 }, { lat: 52.62946, lng: 1.30098 }, {
  lat: 52.62948,
  lng: 1.30086
}, { lat: 52.62951, lng: 1.30049 }, { lat: 52.62951, lng: 1.30011 }, { lat: 52.62951, lng: 1.29997 }, { lat: 52.62943, lng: 1.29949 }, { lat: 52.62935, lng: 1.29904 }, { lat: 52.62928, lng: 1.29836 }, {
  lat: 52.62932,
  lng: 1.29835
}, { lat: 52.62942, lng: 1.2981 }, { lat: 52.6295, lng: 1.29793 }, { lat: 52.62965, lng: 1.29774 }, { lat: 52.62982, lng: 1.2975 }, { lat: 52.62991, lng: 1.29737 }, { lat: 52.63002, lng: 1.29727 }, {
  lat: 52.6302,
  lng: 1.29708
}, { lat: 52.63037, lng: 1.2969 }, { lat: 52.63037, lng: 1.2969 }, { lat: 52.63043, lng: 1.29684 }, { lat: 52.63048, lng: 1.29683 }, { lat: 52.63058, lng: 1.29678 }, { lat: 52.63085, lng: 1.2966 }, {
  lat: 52.63088,
  lng: 1.29672
}, { lat: 52.63135, lng: 1.2966 }, { lat: 52.63161, lng: 1.29622 }, { lat: 52.63187, lng: 1.29584 }, { lat: 52.63198, lng: 1.29581 }, { lat: 52.63207, lng: 1.29619 }, { lat: 52.63223, lng: 1.29643 }, {
  lat: 52.63248,
  lng: 1.29667
}, { lat: 52.63275, lng: 1.29689 }, { lat: 52.63284, lng: 1.29703 }, { lat: 52.63289, lng: 1.29718 }, { lat: 52.63289, lng: 1.29718 }, { lat: 52.63294, lng: 1.2973 }, { lat: 52.63306, lng: 1.29785 }, {
  lat: 52.63306,
  lng: 1.29785
}, { lat: 52.63317, lng: 1.29834 }, { lat: 52.63317, lng: 1.29834 }, { lat: 52.63338, lng: 1.29868 }, { lat: 52.63369, lng: 1.29915 }, { lat: 52.63383, lng: 1.2994 }, { lat: 52.63397, lng: 1.29965 }, {
  lat: 52.63415,
  lng: 1.30008
}, { lat: 52.63429, lng: 1.30046 }, { lat: 52.63443, lng: 1.30084 }, { lat: 52.63463, lng: 1.30116 }, { lat: 52.63479, lng: 1.30138 }, { lat: 52.63494, lng: 1.30161 }, { lat: 52.63511, lng: 1.30192 }, {
  lat: 52.63527,
  lng: 1.30225
}, { lat: 52.63534, lng: 1.30262 }, { lat: 52.63534, lng: 1.30262 }, { lat: 52.6353, lng: 1.30293 }, { lat: 52.6353, lng: 1.30293 }, { lat: 52.63506, lng: 1.30328 }, { lat: 52.63506, lng: 1.30328 }, {
  lat: 52.63494,
  lng: 1.30344
}, { lat: 52.63484, lng: 1.30357 }, { lat: 52.63469, lng: 1.3038 }, { lat: 52.63455, lng: 1.30402 }, { lat: 52.63444, lng: 1.3043 }, { lat: 52.63432, lng: 1.3046 }, {
  lat: 52.63428,
  lng: 1.30495
}]

let creativeCoords = [{ lat: 52.63415, lng: 1.30888 }, { lat: 52.63432, lng: 1.30885 }, { lat: 52.63448, lng: 1.3088 }, { lat: 52.63465, lng: 1.30874 }, { lat: 52.63484, lng: 1.30859 }, {
  lat: 52.63511,
  lng: 1.30804
}, { lat: 52.63529, lng: 1.30759 }, { lat: 52.63558, lng: 1.3068 }, { lat: 52.63586, lng: 1.30591 }, { lat: 52.63608, lng: 1.30513 }, { lat: 52.63629, lng: 1.30439 }, { lat: 52.63637, lng: 1.3037 }, {
  lat: 52.6364,
  lng: 1.30307
}, { lat: 52.63638, lng: 1.30226 }, { lat: 52.63633, lng: 1.30162 }, { lat: 52.63627, lng: 1.30123 }, { lat: 52.63621, lng: 1.30083 }, { lat: 52.63615, lng: 1.30047 }, { lat: 52.63609, lng: 1.3 }, {
  lat: 52.63605,
  lng: 1.29979
}, { lat: 52.63586, lng: 1.29882 }, { lat: 52.63579, lng: 1.29834 }, { lat: 52.63569, lng: 1.29778 }, { lat: 52.63562, lng: 1.29738 }, { lat: 52.63554, lng: 1.29692 }, { lat: 52.63548, lng: 1.29655 }, {
  lat: 52.63542,
  lng: 1.2961
}, { lat: 52.63536, lng: 1.29566 }, { lat: 52.63531, lng: 1.29507 }, { lat: 52.63528, lng: 1.29442 }, { lat: 52.63526, lng: 1.29375 }, { lat: 52.63526, lng: 1.29295 }, { lat: 52.63527, lng: 1.29277 }, {
  lat: 52.63527,
  lng: 1.29264
}, { lat: 52.63531, lng: 1.29202 }, { lat: 52.63535, lng: 1.29079 }, { lat: 52.63536, lng: 1.2898 }, { lat: 52.63538, lng: 1.28898 }, { lat: 52.63538, lng: 1.28786 }, { lat: 52.63531, lng: 1.28785 }, {
  lat: 52.63523,
  lng: 1.28783
}, { lat: 52.63518, lng: 1.28776 }, { lat: 52.63514, lng: 1.28769 }, { lat: 52.63511, lng: 1.28762 }, { lat: 52.63499, lng: 1.28766 }, { lat: 52.63481, lng: 1.28766 }, { lat: 52.6347, lng: 1.28764 }, {
  lat: 52.63458,
  lng: 1.2876
}, { lat: 52.63448, lng: 1.28754 }, { lat: 52.63438, lng: 1.28746 }, { lat: 52.63421, lng: 1.2873 }, { lat: 52.63397, lng: 1.28706 }, { lat: 52.63379, lng: 1.28687 }, { lat: 52.63378, lng: 1.28688 }, {
  lat: 52.63376,
  lng: 1.28691
}, { lat: 52.6337, lng: 1.287 }, { lat: 52.6336, lng: 1.28712 }, { lat: 52.63339, lng: 1.28735 }, { lat: 52.63329, lng: 1.28745 }, { lat: 52.63319, lng: 1.28755 }, { lat: 52.6331, lng: 1.28764 }, {
  lat: 52.63296,
  lng: 1.28776
}, { lat: 52.63287, lng: 1.28783 }, { lat: 52.63279, lng: 1.2879 }, { lat: 52.63265, lng: 1.28802 }, { lat: 52.63252, lng: 1.28812 }, { lat: 52.63238, lng: 1.28825 }, { lat: 52.6323, lng: 1.28833 }, {
  lat: 52.63219,
  lng: 1.28847
}, { lat: 52.63208, lng: 1.28861 }, { lat: 52.63197, lng: 1.28875 }, { lat: 52.63193, lng: 1.28879 }, { lat: 52.63189, lng: 1.28879 }, { lat: 52.63188, lng: 1.2888 }, { lat: 52.63177, lng: 1.28907 }, {
  lat: 52.6317,
  lng: 1.28922
}, { lat: 52.63162, lng: 1.28937 }, { lat: 52.63152, lng: 1.28956 }, { lat: 52.63143, lng: 1.28974 }, { lat: 52.63134, lng: 1.28991 }, { lat: 52.63128, lng: 1.29007 }, { lat: 52.63123, lng: 1.29025 }, {
  lat: 52.63115,
  lng: 1.2905
}, { lat: 52.63102, lng: 1.291 }, { lat: 52.63096, lng: 1.29124 }, { lat: 52.63089, lng: 1.2915 }, { lat: 52.63082, lng: 1.29175 }, { lat: 52.63081, lng: 1.2918 }, { lat: 52.63076, lng: 1.29197 }, {
  lat: 52.63078,
  lng: 1.29211
}, { lat: 52.63079, lng: 1.29218 }, { lat: 52.63079, lng: 1.29228 }, { lat: 52.63079, lng: 1.29255 }, { lat: 52.63078, lng: 1.2928 }, { lat: 52.63076, lng: 1.29303 }, { lat: 52.63071, lng: 1.29342 }, {
  lat: 52.63066,
  lng: 1.29378
}, { lat: 52.63061, lng: 1.29421 }, { lat: 52.63058, lng: 1.29445 }, { lat: 52.63057, lng: 1.29503 }, { lat: 52.63057, lng: 1.29527 }, { lat: 52.6306, lng: 1.29568 }, { lat: 52.6306, lng: 1.2958 }, {
  lat: 52.63064,
  lng: 1.29581
}, { lat: 52.63068, lng: 1.29582 }, { lat: 52.63072, lng: 1.29587 }, { lat: 52.63074, lng: 1.29593 }, { lat: 52.63076, lng: 1.29602 }, { lat: 52.63081, lng: 1.29638 }, { lat: 52.63085, lng: 1.2966 }, {
  lat: 52.63088,
  lng: 1.29672
}, { lat: 52.63135, lng: 1.2966 }, { lat: 52.63161, lng: 1.29622 }, { lat: 52.63187, lng: 1.29584 }, { lat: 52.63198, lng: 1.29581 }, { lat: 52.63207, lng: 1.29619 }, { lat: 52.63223, lng: 1.29643 }, {
  lat: 52.63248,
  lng: 1.29667
}, { lat: 52.63275, lng: 1.29689 }, { lat: 52.63284, lng: 1.29703 }, { lat: 52.63289, lng: 1.29718 }, { lat: 52.63294, lng: 1.2973 }, { lat: 52.63306, lng: 1.29785 }, { lat: 52.63317, lng: 1.29834 }, {
  lat: 52.63338,
  lng: 1.29868
}, { lat: 52.63369, lng: 1.29915 }, { lat: 52.63397, lng: 1.29965 }, { lat: 52.63415, lng: 1.30008 }, { lat: 52.63443, lng: 1.30084 }, { lat: 52.63463, lng: 1.30116 }, { lat: 52.63479, lng: 1.30138 }, {
  lat: 52.63494,
  lng: 1.30161
}, { lat: 52.63511, lng: 1.30192 }, { lat: 52.63527, lng: 1.30225 }, { lat: 52.63534, lng: 1.30262 }, { lat: 52.6353, lng: 1.30293 }, { lat: 52.63506, lng: 1.30328 }, { lat: 52.63494, lng: 1.30344 }, {
  lat: 52.63484,
  lng: 1.30357
}, { lat: 52.63455, lng: 1.30402 }, { lat: 52.63444, lng: 1.3043 }, { lat: 52.63432, lng: 1.3046 }, { lat: 52.63428, lng: 1.30495 }, { lat: 52.63423, lng: 1.30531 }, { lat: 52.63429, lng: 1.3059 }, {
  lat: 52.63434,
  lng: 1.30653
}, { lat: 52.6344, lng: 1.30775 }, { lat: 52.63439, lng: 1.30819 }, { lat: 52.63434, lng: 1.30842 }, { lat: 52.63425, lng: 1.30859 }]

let kingsCoords = [{ lat: 52.62789, lng: 1.30588 }, {
  lat: 52.62778,
  lng: 1.30581
}, { lat: 52.62771, lng: 1.30574 }, { lat: 52.62758, lng: 1.30566 }, { lat: 52.62749, lng: 1.30561 }, { lat: 52.62739, lng: 1.30551 }, { lat: 52.62735, lng: 1.30546 }, { lat: 52.62724, lng: 1.30539 }, {
  lat: 52.62717,
  lng: 1.30531
}, { lat: 52.62708, lng: 1.3052 }, { lat: 52.62692, lng: 1.30501 }, { lat: 52.62684, lng: 1.30489 }, { lat: 52.62665, lng: 1.3046 }, { lat: 52.62662, lng: 1.30457 }, { lat: 52.62638, lng: 1.30409 }, {
  lat: 52.62625,
  lng: 1.30382
}, { lat: 52.62619, lng: 1.30373 }, { lat: 52.62616, lng: 1.30367 }, { lat: 52.6261, lng: 1.30372 }, { lat: 52.62599, lng: 1.30361 }, { lat: 52.62585, lng: 1.3035 }, { lat: 52.62574, lng: 1.30345 }, {
  lat: 52.6257,
  lng: 1.30335
}, { lat: 52.6257, lng: 1.30335 }, { lat: 52.62557, lng: 1.30334 }, { lat: 52.62546, lng: 1.30334 }, { lat: 52.6254, lng: 1.30337 }, { lat: 52.62526, lng: 1.3034 }, { lat: 52.62501, lng: 1.30353 }, {
  lat: 52.62484,
  lng: 1.30361
}, { lat: 52.6247, lng: 1.30367 }, { lat: 52.62427, lng: 1.30387 }, { lat: 52.62384, lng: 1.30403 }, { lat: 52.62345, lng: 1.30416 }, { lat: 52.62318, lng: 1.30426 }, { lat: 52.62287, lng: 1.30448 }, {
  lat: 52.62282,
  lng: 1.30452
}, { lat: 52.62276, lng: 1.30451 }, { lat: 52.62251, lng: 1.30474 }, { lat: 52.62249, lng: 1.30483 }, { lat: 52.62236, lng: 1.30495 }, { lat: 52.62229, lng: 1.30504 }, { lat: 52.62206, lng: 1.30534 }, {
  lat: 52.62162,
  lng: 1.30596
}, { lat: 52.62153, lng: 1.30613 }, { lat: 52.62145, lng: 1.30626 }, { lat: 52.62131, lng: 1.30659 }, { lat: 52.62122, lng: 1.30649 }, { lat: 52.62115, lng: 1.30641 }, { lat: 52.6211, lng: 1.30635 }, {
  lat: 52.62104,
  lng: 1.30628
}, { lat: 52.62101, lng: 1.30623 }, { lat: 52.62089, lng: 1.30604 }, { lat: 52.62084, lng: 1.30598 }, { lat: 52.6208, lng: 1.30592 }, { lat: 52.62077, lng: 1.3059 }, { lat: 52.62073, lng: 1.30591 }, {
  lat: 52.62069,
  lng: 1.30594
}, { lat: 52.62067, lng: 1.30597 }, { lat: 52.62025, lng: 1.30654 }, { lat: 52.62005, lng: 1.30682 }, { lat: 52.61984, lng: 1.30709 }, { lat: 52.61984, lng: 1.30709 }, { lat: 52.61974, lng: 1.30689 }, {
  lat: 52.61965,
  lng: 1.3067
}, { lat: 52.61957, lng: 1.3065 }, { lat: 52.61955, lng: 1.30646 }, { lat: 52.61953, lng: 1.30639 }, { lat: 52.61953, lng: 1.30632 }, { lat: 52.61953, lng: 1.30624 }, { lat: 52.61953, lng: 1.30619 }, {
  lat: 52.61957,
  lng: 1.30607
}, { lat: 52.61963, lng: 1.30593 }, { lat: 52.6197, lng: 1.30578 }, { lat: 52.61977, lng: 1.30562 }, { lat: 52.6199, lng: 1.30532 }, { lat: 52.61994, lng: 1.30524 }, { lat: 52.61997, lng: 1.30507 }, {
  lat: 52.62002,
  lng: 1.30484
}, { lat: 52.62002, lng: 1.30473 }, { lat: 52.62001, lng: 1.30455 }, { lat: 52.62002, lng: 1.30442 }, { lat: 52.62013, lng: 1.30397 }, { lat: 52.62019, lng: 1.30372 }, { lat: 52.62024, lng: 1.30347 }, {
  lat: 52.62026,
  lng: 1.30336
}, { lat: 52.62028, lng: 1.30323 }, { lat: 52.62032, lng: 1.303 }, { lat: 52.62033, lng: 1.30282 }, { lat: 52.62034, lng: 1.30268 }, { lat: 52.62035, lng: 1.30255 }, { lat: 52.62034, lng: 1.30247 }, {
  lat: 52.62028,
  lng: 1.30235
}, { lat: 52.62028, lng: 1.30234 }, { lat: 52.62035, lng: 1.30222 }, { lat: 52.62045, lng: 1.30205 }, { lat: 52.62063, lng: 1.30176 }, { lat: 52.62072, lng: 1.3016 }, { lat: 52.62079, lng: 1.30148 }, {
  lat: 52.62084,
  lng: 1.30136
}, { lat: 52.62086, lng: 1.30125 }, { lat: 52.6209, lng: 1.30125 }, { lat: 52.62094, lng: 1.30124 }, { lat: 52.621, lng: 1.30123 }, { lat: 52.62105, lng: 1.30119 }, { lat: 52.6211, lng: 1.30115 }, {
  lat: 52.62115,
  lng: 1.3011
}, { lat: 52.62118, lng: 1.30106 }, { lat: 52.62123, lng: 1.30098 }, { lat: 52.62127, lng: 1.30093 }, { lat: 52.6213, lng: 1.30088 }, { lat: 52.62137, lng: 1.30079 }, { lat: 52.62143, lng: 1.3007 }, {
  lat: 52.62149,
  lng: 1.3006
}, { lat: 52.62155, lng: 1.30051 }, { lat: 52.62161, lng: 1.30039 }, { lat: 52.62168, lng: 1.30027 }, { lat: 52.62174, lng: 1.30017 }, { lat: 52.62179, lng: 1.30008 }, { lat: 52.62181, lng: 1.30004 }, {
  lat: 52.62185,
  lng: 1.29996
}, { lat: 52.62189, lng: 1.29988 }, { lat: 52.62194, lng: 1.29978 }, { lat: 52.62198, lng: 1.2997 }, { lat: 52.62202, lng: 1.29965 }, { lat: 52.62206, lng: 1.29958 }, { lat: 52.62209, lng: 1.29954 }, {
  lat: 52.62212,
  lng: 1.29951
}, { lat: 52.62216, lng: 1.29946 }, { lat: 52.62221, lng: 1.29942 }, { lat: 52.62227, lng: 1.29936 }, { lat: 52.62234, lng: 1.29931 }, { lat: 52.6224, lng: 1.29925 }, { lat: 52.62246, lng: 1.2992 }, {
  lat: 52.62252,
  lng: 1.29915
}, { lat: 52.62264, lng: 1.29905 }, { lat: 52.62271, lng: 1.29899 }, { lat: 52.62283, lng: 1.29889 }, { lat: 52.62295, lng: 1.29879 }, { lat: 52.62307, lng: 1.29869 }, { lat: 52.6232, lng: 1.29857 }, {
  lat: 52.62329,
  lng: 1.29849
}, { lat: 52.62339, lng: 1.29839 }, { lat: 52.6235, lng: 1.29829 }, { lat: 52.62361, lng: 1.29819 }, { lat: 52.62367, lng: 1.29814 }, { lat: 52.6237, lng: 1.29811 }, { lat: 52.62376, lng: 1.29806 }, {
  lat: 52.62382,
  lng: 1.29801
}, { lat: 52.62389, lng: 1.29795 }, { lat: 52.62395, lng: 1.29789 }, { lat: 52.62403, lng: 1.29783 }, { lat: 52.62414, lng: 1.29774 }, { lat: 52.6242, lng: 1.29769 }, { lat: 52.62426, lng: 1.29762 }, {
  lat: 52.62434,
  lng: 1.29754
}, { lat: 52.62443, lng: 1.29744 }, { lat: 52.62452, lng: 1.29734 }, { lat: 52.62461, lng: 1.29725 }, { lat: 52.62471, lng: 1.29713 }, { lat: 52.62477, lng: 1.29706 }, { lat: 52.62481, lng: 1.29702 }, {
  lat: 52.62487,
  lng: 1.29694
}, { lat: 52.62494, lng: 1.29685 }, { lat: 52.62498, lng: 1.29679 }, { lat: 52.62504, lng: 1.29673 }, { lat: 52.62509, lng: 1.29669 }, { lat: 52.62513, lng: 1.29665 }, { lat: 52.62517, lng: 1.29663 }, {
  lat: 52.62522,
  lng: 1.29659
}, { lat: 52.62527, lng: 1.29656 }, { lat: 52.62534, lng: 1.29652 }, { lat: 52.62538, lng: 1.2965 }, { lat: 52.62541, lng: 1.29648 }, { lat: 52.62544, lng: 1.29647 }, { lat: 52.62557, lng: 1.29644 }, {
  lat: 52.62567,
  lng: 1.29641
}, { lat: 52.62578, lng: 1.29637 }, { lat: 52.62587, lng: 1.29635 }, { lat: 52.62588, lng: 1.29635 }, { lat: 52.62589, lng: 1.29635 }, { lat: 52.62592, lng: 1.29641 }, { lat: 52.62599, lng: 1.29648 }, {
  lat: 52.62604,
  lng: 1.29652
}, { lat: 52.6261, lng: 1.29657 }, { lat: 52.62618, lng: 1.29664 }, { lat: 52.6263, lng: 1.29674 }, { lat: 52.62639, lng: 1.29683 }, { lat: 52.62648, lng: 1.29692 }, { lat: 52.62654, lng: 1.297 }, {
  lat: 52.6266,
  lng: 1.29715
}, { lat: 52.62667, lng: 1.29733 }, { lat: 52.62673, lng: 1.29748 }, { lat: 52.62673, lng: 1.29748 }, { lat: 52.62677, lng: 1.29753 }, { lat: 52.62684, lng: 1.29759 }, { lat: 52.6269, lng: 1.29765 }, {
  lat: 52.62699,
  lng: 1.29773
}, { lat: 52.62703, lng: 1.29777 }, { lat: 52.62709, lng: 1.29781 }, { lat: 52.62717, lng: 1.29784 }, { lat: 52.62724, lng: 1.29787 }, { lat: 52.62734, lng: 1.29789 }, { lat: 52.62744, lng: 1.29793 }, {
  lat: 52.62747,
  lng: 1.29795
}, { lat: 52.62755, lng: 1.29802 }, { lat: 52.62776, lng: 1.29829 }, { lat: 52.62781, lng: 1.2983 }, { lat: 52.62786, lng: 1.2983 }, { lat: 52.62791, lng: 1.29829 }, { lat: 52.62795, lng: 1.29827 }, {
  lat: 52.628,
  lng: 1.29824
}, { lat: 52.62801, lng: 1.29815 }, { lat: 52.62802, lng: 1.29806 }, { lat: 52.62804, lng: 1.29795 }, { lat: 52.62806, lng: 1.29787 }, { lat: 52.62809, lng: 1.2978 }, { lat: 52.62813, lng: 1.29774 }, {
  lat: 52.62817,
  lng: 1.29769
}, { lat: 52.62822, lng: 1.29767 }, { lat: 52.62829, lng: 1.29765 }, { lat: 52.62833, lng: 1.29765 }, { lat: 52.6284, lng: 1.29766 }, { lat: 52.62849, lng: 1.29766 }, { lat: 52.62857, lng: 1.29766 }, {
  lat: 52.62865,
  lng: 1.29767
}, { lat: 52.62875, lng: 1.29767 }, { lat: 52.62883, lng: 1.29767 }, { lat: 52.62889, lng: 1.29766 }, { lat: 52.62894, lng: 1.29767 }, { lat: 52.62902, lng: 1.2977 }, { lat: 52.62906, lng: 1.29772 }, {
  lat: 52.62918,
  lng: 1.2978
}, { lat: 52.62924, lng: 1.29784 }, { lat: 52.62931, lng: 1.29791 }, { lat: 52.62934, lng: 1.29793 }, { lat: 52.62938, lng: 1.29794 }, { lat: 52.62943, lng: 1.29794 }, { lat: 52.62943, lng: 1.29794 }, {
  lat: 52.62946,
  lng: 1.29793
}, { lat: 52.6295, lng: 1.29793 }, { lat: 52.62942, lng: 1.2981 }, { lat: 52.62932, lng: 1.29835 }, { lat: 52.62928, lng: 1.29836 }, { lat: 52.62935, lng: 1.29904 }, { lat: 52.62935, lng: 1.29904 }, {
  lat: 52.62943,
  lng: 1.29949
}, { lat: 52.62951, lng: 1.29997 }, { lat: 52.62951, lng: 1.30011 }, { lat: 52.62951, lng: 1.30049 }, { lat: 52.62948, lng: 1.30086 }, { lat: 52.62943, lng: 1.30122 }, { lat: 52.62932, lng: 1.30167 }, {
  lat: 52.62916,
  lng: 1.30218
}, { lat: 52.62883, lng: 1.30311 }, { lat: 52.62849, lng: 1.30408 }, { lat: 52.62825, lng: 1.30475 }]

let businessCoords = [{ lat: 52.6233, lng: 1.28925 }, { lat: 52.62353, lng: 1.28966 }, {
  lat: 52.6239,
  lng: 1.2902
}, { lat: 52.62418, lng: 1.29064 }, { lat: 52.6246, lng: 1.29112 }, { lat: 52.62488, lng: 1.29148 }, { lat: 52.62498, lng: 1.29165 }, { lat: 52.62503, lng: 1.29173 }, { lat: 52.62509, lng: 1.29187 }, {
  lat: 52.62519,
  lng: 1.29208
}, { lat: 52.62525, lng: 1.29222 }, { lat: 52.62548, lng: 1.29279 }, { lat: 52.62573, lng: 1.29329 }, { lat: 52.62581, lng: 1.29339 }, { lat: 52.62591, lng: 1.29355 }, { lat: 52.62596, lng: 1.29362 }, {
  lat: 52.62619,
  lng: 1.29389
}, { lat: 52.62613, lng: 1.29393 }, { lat: 52.62608, lng: 1.29395 }, { lat: 52.62602, lng: 1.29406 }, { lat: 52.62599, lng: 1.2942 }, { lat: 52.62599, lng: 1.29433 }, { lat: 52.62599, lng: 1.29447 }, {
  lat: 52.62599,
  lng: 1.29469
}, { lat: 52.62598, lng: 1.29483 }, { lat: 52.62593, lng: 1.295 }, { lat: 52.62588, lng: 1.29509 }, { lat: 52.62583, lng: 1.29518 }, { lat: 52.62575, lng: 1.29527 }, { lat: 52.62559, lng: 1.29532 }, {
  lat: 52.62541,
  lng: 1.29538
}, { lat: 52.62533, lng: 1.29541 }, { lat: 52.62524, lng: 1.29544 }, { lat: 52.62519, lng: 1.29546 }, { lat: 52.62505, lng: 1.29546 }, { lat: 52.62494, lng: 1.29545 }, { lat: 52.62484, lng: 1.29542 }, {
  lat: 52.6248,
  lng: 1.29539
}, { lat: 52.6248, lng: 1.29539 }, { lat: 52.6248, lng: 1.29539 }, { lat: 52.6248, lng: 1.29539 }, { lat: 52.62472, lng: 1.29571 }, { lat: 52.62469, lng: 1.2957 }, { lat: 52.62432, lng: 1.29564 }, {
  lat: 52.62352,
  lng: 1.29648
}, { lat: 52.623, lng: 1.29705 }, { lat: 52.62326, lng: 1.2977 }, { lat: 52.62299, lng: 1.29798 }, { lat: 52.6232, lng: 1.29857 }, { lat: 52.62307, lng: 1.29869 }, { lat: 52.62295, lng: 1.29879 }, {
  lat: 52.62283,
  lng: 1.29889
}, { lat: 52.62271, lng: 1.29899 }, { lat: 52.62264, lng: 1.29905 }, { lat: 52.62252, lng: 1.29915 }, { lat: 52.62246, lng: 1.2992 }, { lat: 52.6224, lng: 1.29925 }, { lat: 52.62234, lng: 1.29931 }, {
  lat: 52.62227,
  lng: 1.29936
}, { lat: 52.62221, lng: 1.29942 }, { lat: 52.62216, lng: 1.29946 }, { lat: 52.62212, lng: 1.29951 }, { lat: 52.62209, lng: 1.29954 }, { lat: 52.62206, lng: 1.29958 }, { lat: 52.62202, lng: 1.29965 }, {
  lat: 52.62198,
  lng: 1.2997
}, { lat: 52.62194, lng: 1.29978 }, { lat: 52.62189, lng: 1.29988 }, { lat: 52.62185, lng: 1.29996 }, { lat: 52.62181, lng: 1.30004 }, { lat: 52.62179, lng: 1.30008 }, { lat: 52.62174, lng: 1.30017 }, {
  lat: 52.62168,
  lng: 1.30027
}, { lat: 52.62161, lng: 1.30039 }, { lat: 52.62155, lng: 1.30051 }, { lat: 52.62149, lng: 1.3006 }, { lat: 52.62143, lng: 1.3007 }, { lat: 52.62137, lng: 1.30079 }, { lat: 52.6213, lng: 1.30088 }, {
  lat: 52.62127,
  lng: 1.30093
}, { lat: 52.62123, lng: 1.30098 }, { lat: 52.62118, lng: 1.30106 }, { lat: 52.62115, lng: 1.3011 }, { lat: 52.6211, lng: 1.30115 }, { lat: 52.62105, lng: 1.30119 }, { lat: 52.621, lng: 1.30123 }, {
  lat: 52.62094,
  lng: 1.30124
}, { lat: 52.6209, lng: 1.30125 }, { lat: 52.62086, lng: 1.30125 }, { lat: 52.62089, lng: 1.30089 }, { lat: 52.62092, lng: 1.30026 }, { lat: 52.62095, lng: 1.29987 }, { lat: 52.62104, lng: 1.29944 }, {
  lat: 52.62133,
  lng: 1.29839
}, { lat: 52.62189, lng: 1.29665 }, { lat: 52.62248, lng: 1.29493 }, { lat: 52.62283, lng: 1.29388 }, { lat: 52.62291, lng: 1.29355 }, { lat: 52.62261, lng: 1.29322 }, { lat: 52.6224, lng: 1.29294 }, {
  lat: 52.62232,
  lng: 1.29283
}, { lat: 52.62224, lng: 1.29269 }, { lat: 52.62213, lng: 1.29262 }, { lat: 52.62202, lng: 1.29261 }, { lat: 52.62201, lng: 1.29246 }, { lat: 52.62197, lng: 1.29233 }, { lat: 52.62187, lng: 1.29221 }, {
  lat: 52.62177,
  lng: 1.29207
}, { lat: 52.62256, lng: 1.29063 }]

let castleCoords = [{ lat: 52.6286, lng: 1.28608 }, { lat: 52.62875, lng: 1.28629 }, { lat: 52.62877, lng: 1.28628 }, { lat: 52.62884, lng: 1.28647 }, {
  lat: 52.62891,
  lng: 1.28662
}, { lat: 52.62899, lng: 1.2868 }, { lat: 52.62908, lng: 1.28702 }, { lat: 52.62916, lng: 1.28721 }, { lat: 52.62926, lng: 1.28749 }, { lat: 52.62937, lng: 1.2878 }, { lat: 52.6294, lng: 1.28788 }, {
  lat: 52.62942,
  lng: 1.28796
}, { lat: 52.62943, lng: 1.28805 }, { lat: 52.62943, lng: 1.2882 }, { lat: 52.6294, lng: 1.28843 }, { lat: 52.62933, lng: 1.28907 }, { lat: 52.62925, lng: 1.28978 }, { lat: 52.62916, lng: 1.29059 }, {
  lat: 52.62911,
  lng: 1.29093
}, { lat: 52.62909, lng: 1.29116 }, { lat: 52.62908, lng: 1.29137 }, { lat: 52.62909, lng: 1.29161 }, { lat: 52.62909, lng: 1.29174 }, { lat: 52.62908, lng: 1.29183 }, { lat: 52.62907, lng: 1.29188 }, {
  lat: 52.62905,
  lng: 1.29193
}, { lat: 52.62894, lng: 1.29204 }, { lat: 52.62889, lng: 1.29212 }, { lat: 52.62887, lng: 1.29223 }, { lat: 52.62883, lng: 1.29314 }, { lat: 52.62884, lng: 1.29324 }, { lat: 52.62886, lng: 1.2933 }, {
  lat: 52.6289,
  lng: 1.29335
}, { lat: 52.62906, lng: 1.29339 }, { lat: 52.62906, lng: 1.2937 }, { lat: 52.62907, lng: 1.29417 }, { lat: 52.6291, lng: 1.2947 }, { lat: 52.62918, lng: 1.29486 }, { lat: 52.62928, lng: 1.29502 }, {
  lat: 52.62935,
  lng: 1.29515
}, { lat: 52.62941, lng: 1.29529 }, { lat: 52.62947, lng: 1.29545 }, { lat: 52.6295, lng: 1.29557 }, { lat: 52.62956, lng: 1.29574 }, { lat: 52.62962, lng: 1.29586 }, { lat: 52.62967, lng: 1.29592 }, {
  lat: 52.62977,
  lng: 1.29605
}, { lat: 52.6298, lng: 1.29612 }, { lat: 52.62983, lng: 1.2962 }, { lat: 52.62989, lng: 1.29637 }, { lat: 52.62991, lng: 1.29648 }, { lat: 52.62993, lng: 1.29676 }, { lat: 52.62996, lng: 1.29702 }, {
  lat: 52.63002,
  lng: 1.29727
}, { lat: 52.62991, lng: 1.29737 }, { lat: 52.62982, lng: 1.2975 }, { lat: 52.62965, lng: 1.29774 }, { lat: 52.6295, lng: 1.29793 }, { lat: 52.62946, lng: 1.29793 }, { lat: 52.62943, lng: 1.29794 }, {
  lat: 52.62943,
  lng: 1.29794
}, { lat: 52.62938, lng: 1.29794 }, { lat: 52.62934, lng: 1.29793 }, { lat: 52.62931, lng: 1.29791 }, { lat: 52.62924, lng: 1.29784 }, { lat: 52.62918, lng: 1.2978 }, { lat: 52.62906, lng: 1.29772 }, {
  lat: 52.62902,
  lng: 1.2977
}, { lat: 52.62894, lng: 1.29767 }, { lat: 52.62889, lng: 1.29766 }, { lat: 52.62883, lng: 1.29767 }, { lat: 52.62875, lng: 1.29767 }, { lat: 52.62865, lng: 1.29767 }, { lat: 52.62857, lng: 1.29766 }, {
  lat: 52.62849,
  lng: 1.29766
}, { lat: 52.6284, lng: 1.29766 }, { lat: 52.6284, lng: 1.29766 }, { lat: 52.6284, lng: 1.29766 }, { lat: 52.6284, lng: 1.29766 }, { lat: 52.6284, lng: 1.29766 }, { lat: 52.6284, lng: 1.29766 }, {
  lat: 52.6284,
  lng: 1.29766
}, { lat: 52.6284, lng: 1.29766 }, { lat: 52.6284, lng: 1.29766 }, { lat: 52.6284, lng: 1.29766 }, { lat: 52.6284, lng: 1.29766 }, { lat: 52.6284, lng: 1.29766 }, { lat: 52.6284, lng: 1.29766 }, {
  lat: 52.6284,
  lng: 1.29766
}, { lat: 52.6284, lng: 1.29766 }, { lat: 52.6284, lng: 1.29766 }, { lat: 52.6284, lng: 1.29766 }, { lat: 52.6284, lng: 1.29766 }, { lat: 52.6284, lng: 1.29766 }, { lat: 52.6284, lng: 1.29766 }, {
  lat: 52.6284,
  lng: 1.29766
}, { lat: 52.6284, lng: 1.29766 }, { lat: 52.62833, lng: 1.29765 }, { lat: 52.62829, lng: 1.29765 }, { lat: 52.62822, lng: 1.29767 }, { lat: 52.62817, lng: 1.29769 }, { lat: 52.62813, lng: 1.29774 }, {
  lat: 52.62809,
  lng: 1.2978
}, { lat: 52.62806, lng: 1.29787 }, { lat: 52.62804, lng: 1.29795 }, { lat: 52.62802, lng: 1.29806 }, { lat: 52.62801, lng: 1.29815 }, { lat: 52.628, lng: 1.29824 }, { lat: 52.62795, lng: 1.29827 }, {
  lat: 52.62791,
  lng: 1.29829
}, { lat: 52.62786, lng: 1.2983 }, { lat: 52.62781, lng: 1.2983 }, { lat: 52.62776, lng: 1.29829 }, { lat: 52.62755, lng: 1.29802 }, { lat: 52.62747, lng: 1.29795 }, { lat: 52.62744, lng: 1.29793 }, {
  lat: 52.62734,
  lng: 1.29789
}, { lat: 52.62724, lng: 1.29787 }, { lat: 52.62717, lng: 1.29784 }, { lat: 52.62709, lng: 1.29781 }, { lat: 52.62703, lng: 1.29777 }, { lat: 52.62699, lng: 1.29773 }, { lat: 52.6269, lng: 1.29765 }, {
  lat: 52.62684,
  lng: 1.29759
}, { lat: 52.62677, lng: 1.29753 }, { lat: 52.62673, lng: 1.29748 }, { lat: 52.62671, lng: 1.29743 }, { lat: 52.62667, lng: 1.29733 }, { lat: 52.6266, lng: 1.29715 }, { lat: 52.62654, lng: 1.297 }, {
  lat: 52.62654,
  lng: 1.297
}, { lat: 52.62648, lng: 1.29692 }, { lat: 52.62639, lng: 1.29683 }, { lat: 52.6263, lng: 1.29674 }, { lat: 52.62618, lng: 1.29664 }, { lat: 52.6261, lng: 1.29657 }, { lat: 52.62604, lng: 1.29652 }, {
  lat: 52.62599,
  lng: 1.29648
}, { lat: 52.62592, lng: 1.29641 }, { lat: 52.62589, lng: 1.29635 }, { lat: 52.62588, lng: 1.29635 }, { lat: 52.62587, lng: 1.29635 }, { lat: 52.62578, lng: 1.29637 }, { lat: 52.62567, lng: 1.29641 }, {
  lat: 52.62557,
  lng: 1.29644
}, { lat: 52.62544, lng: 1.29647 }, { lat: 52.62541, lng: 1.29648 }, { lat: 52.62538, lng: 1.2965 }, { lat: 52.62534, lng: 1.29652 }, { lat: 52.62527, lng: 1.29656 }, { lat: 52.62522, lng: 1.29659 }, {
  lat: 52.62517,
  lng: 1.29663
}, { lat: 52.62513, lng: 1.29665 }, { lat: 52.62509, lng: 1.29669 }, { lat: 52.62504, lng: 1.29673 }, { lat: 52.62498, lng: 1.29679 }, { lat: 52.62494, lng: 1.29685 }, { lat: 52.62487, lng: 1.29694 }, {
  lat: 52.62481,
  lng: 1.29702
}, { lat: 52.62477, lng: 1.29706 }, { lat: 52.62471, lng: 1.29713 }, { lat: 52.62461, lng: 1.29725 }, { lat: 52.62452, lng: 1.29734 }, { lat: 52.62443, lng: 1.29744 }, { lat: 52.62434, lng: 1.29754 }, {
  lat: 52.62426,
  lng: 1.29762
}, { lat: 52.6242, lng: 1.29769 }, { lat: 52.62414, lng: 1.29774 }, { lat: 52.62403, lng: 1.29783 }, { lat: 52.62395, lng: 1.29789 }, { lat: 52.62389, lng: 1.29795 }, { lat: 52.62382, lng: 1.29801 }, {
  lat: 52.62376,
  lng: 1.29806
}, { lat: 52.6237, lng: 1.29811 }, { lat: 52.62367, lng: 1.29814 }, { lat: 52.62361, lng: 1.29819 }, { lat: 52.6235, lng: 1.29829 }, { lat: 52.62339, lng: 1.29839 }, { lat: 52.62329, lng: 1.29849 }, {
  lat: 52.6232,
  lng: 1.29857
}, { lat: 52.62299, lng: 1.29798 }, { lat: 52.62326, lng: 1.2977 }, { lat: 52.623, lng: 1.29705 }, { lat: 52.62352, lng: 1.29648 }, { lat: 52.62432, lng: 1.29564 }, { lat: 52.62469, lng: 1.2957 }, {
  lat: 52.62472,
  lng: 1.29571
}, { lat: 52.6248, lng: 1.29539 }, { lat: 52.6248, lng: 1.29539 }, { lat: 52.6248, lng: 1.29539 }, { lat: 52.6248, lng: 1.29539 }, { lat: 52.62484, lng: 1.29542 }, { lat: 52.62494, lng: 1.29545 }, {
  lat: 52.62505,
  lng: 1.29546
}, { lat: 52.62519, lng: 1.29546 }, { lat: 52.62524, lng: 1.29544 }, { lat: 52.62533, lng: 1.29541 }, { lat: 52.62541, lng: 1.29538 }, { lat: 52.62559, lng: 1.29532 }, { lat: 52.62575, lng: 1.29527 }, {
  lat: 52.62583,
  lng: 1.29518
}, { lat: 52.62588, lng: 1.29509 }, { lat: 52.62593, lng: 1.295 }, { lat: 52.62598, lng: 1.29483 }, { lat: 52.62599, lng: 1.29469 }, { lat: 52.62599, lng: 1.29447 }, { lat: 52.62599, lng: 1.29433 }, {
  lat: 52.62599,
  lng: 1.2942
}, { lat: 52.62602, lng: 1.29406 }, { lat: 52.62608, lng: 1.29395 }, { lat: 52.62613, lng: 1.29393 }, { lat: 52.62619, lng: 1.29389 }, { lat: 52.62619, lng: 1.29389 }, { lat: 52.62629, lng: 1.29359 }, {
  lat: 52.62646,
  lng: 1.29322
}, { lat: 52.62663, lng: 1.29279 }, { lat: 52.62688, lng: 1.29229 }, { lat: 52.62699, lng: 1.29202 }, { lat: 52.62714, lng: 1.2915 }, { lat: 52.62752, lng: 1.28983 }, { lat: 52.62766, lng: 1.28927 }, {
  lat: 52.62773,
  lng: 1.2891
}, { lat: 52.62782, lng: 1.28896 }, { lat: 52.62788, lng: 1.28885 }, { lat: 52.6281, lng: 1.28815 }, { lat: 52.62837, lng: 1.28724 }, { lat: 52.62857, lng: 1.28643 }, {
  lat: 52.6286,
  lng: 1.28624
}]

let chapelfieldCoords = [{ lat: 52.62429, lng: 1.29036 }, { lat: 52.62418, lng: 1.29064 }, { lat: 52.6246, lng: 1.29112 }, { lat: 52.62488, lng: 1.29148 }, { lat: 52.62498, lng: 1.29165 }, {
  lat: 52.62503,
  lng: 1.29173
}, { lat: 52.62509, lng: 1.29187 }, { lat: 52.62519, lng: 1.29208 }, { lat: 52.62525, lng: 1.29222 }, { lat: 52.62548, lng: 1.29279 }, { lat: 52.62573, lng: 1.29329 }, { lat: 52.62581, lng: 1.29339 }, {
  lat: 52.62591,
  lng: 1.29355
}, { lat: 52.62596, lng: 1.29362 }, { lat: 52.62619, lng: 1.29389 }, { lat: 52.62629, lng: 1.29359 }, { lat: 52.62646, lng: 1.29322 }, { lat: 52.62663, lng: 1.29279 }, { lat: 52.62688, lng: 1.29229 }, {
  lat: 52.62699,
  lng: 1.29202
}, { lat: 52.62714, lng: 1.2915 }, { lat: 52.62752, lng: 1.28983 }, { lat: 52.62766, lng: 1.28927 }, { lat: 52.62773, lng: 1.2891 }, { lat: 52.62782, lng: 1.28896 }, { lat: 52.62788, lng: 1.28885 }, {
  lat: 52.6281,
  lng: 1.28815
}, { lat: 52.62837, lng: 1.28724 }, { lat: 52.62857, lng: 1.28643 }, { lat: 52.6286, lng: 1.28624 }, { lat: 52.6286, lng: 1.28608 }, { lat: 52.62854, lng: 1.286 }, { lat: 52.62846, lng: 1.28586 }, {
  lat: 52.6284,
  lng: 1.28585
}, { lat: 52.62835, lng: 1.28584 }, { lat: 52.62823, lng: 1.28575 }, { lat: 52.62817, lng: 1.28556 }, { lat: 52.62792, lng: 1.28569 }, { lat: 52.62766, lng: 1.28588 }, { lat: 52.62735, lng: 1.28616 }, {
  lat: 52.627,
  lng: 1.28648
}, { lat: 52.62659, lng: 1.28687 }, { lat: 52.62618, lng: 1.28736 }, { lat: 52.62591, lng: 1.28773 }, { lat: 52.62555, lng: 1.28826 }, { lat: 52.62523, lng: 1.28871 }, { lat: 52.62495, lng: 1.28917 }, {
  lat: 52.62441,
  lng: 1.29008
}]

let lanesCoords = [{ lat: 52.63363, lng: 1.28668 }, { lat: 52.63379, lng: 1.28687 }, { lat: 52.63378, lng: 1.28688 }, { lat: 52.63376, lng: 1.28691 }, { lat: 52.6337, lng: 1.287 }, { lat: 52.6336, lng: 1.28712 }, {
  lat: 52.63339,
  lng: 1.28735
}, { lat: 52.63329, lng: 1.28745 }, { lat: 52.63319, lng: 1.28755 }, { lat: 52.6331, lng: 1.28764 }, { lat: 52.63296, lng: 1.28776 }, { lat: 52.63287, lng: 1.28783 }, { lat: 52.63279, lng: 1.2879 }, {
  lat: 52.63265,
  lng: 1.28802
}, { lat: 52.63252, lng: 1.28812 }, { lat: 52.63238, lng: 1.28825 }, { lat: 52.6323, lng: 1.28833 }, { lat: 52.63219, lng: 1.28847 }, { lat: 52.63208, lng: 1.28861 }, { lat: 52.63197, lng: 1.28875 }, {
  lat: 52.63193,
  lng: 1.28879
}, { lat: 52.63189, lng: 1.28879 }, { lat: 52.63188, lng: 1.2888 }, { lat: 52.63177, lng: 1.28907 }, { lat: 52.6317, lng: 1.28922 }, { lat: 52.63162, lng: 1.28937 }, { lat: 52.63152, lng: 1.28956 }, {
  lat: 52.63143,
  lng: 1.28974
}, { lat: 52.63134, lng: 1.28991 }, { lat: 52.63128, lng: 1.29007 }, { lat: 52.63123, lng: 1.29025 }, { lat: 52.63115, lng: 1.2905 }, { lat: 52.63102, lng: 1.291 }, { lat: 52.63096, lng: 1.29124 }, {
  lat: 52.63089,
  lng: 1.2915
}, { lat: 52.63082, lng: 1.29175 }, { lat: 52.63081, lng: 1.2918 }, { lat: 52.63076, lng: 1.29197 }, { lat: 52.63078, lng: 1.29211 }, { lat: 52.63079, lng: 1.29218 }, { lat: 52.63079, lng: 1.29228 }, {
  lat: 52.63079,
  lng: 1.29255
}, { lat: 52.63078, lng: 1.2928 }, { lat: 52.63076, lng: 1.29303 }, { lat: 52.63071, lng: 1.29342 }, { lat: 52.63066, lng: 1.29378 }, { lat: 52.63061, lng: 1.29421 }, { lat: 52.63058, lng: 1.29445 }, {
  lat: 52.63057,
  lng: 1.29503
}, { lat: 52.63057, lng: 1.29527 }, { lat: 52.6306, lng: 1.29568 }, { lat: 52.6306, lng: 1.2958 }, { lat: 52.63064, lng: 1.29581 }, { lat: 52.63068, lng: 1.29582 }, { lat: 52.63072, lng: 1.29587 }, {
  lat: 52.63074,
  lng: 1.29593
}, { lat: 52.63076, lng: 1.29602 }, { lat: 52.63081, lng: 1.29638 }, { lat: 52.63085, lng: 1.2966 }, { lat: 52.63058, lng: 1.29678 }, { lat: 52.63048, lng: 1.29683 }, { lat: 52.63043, lng: 1.29684 }, {
  lat: 52.63037,
  lng: 1.2969
}, { lat: 52.63037, lng: 1.2969 }, { lat: 52.6302, lng: 1.29708 }, { lat: 52.63002, lng: 1.29727 }, { lat: 52.62996, lng: 1.29702 }, { lat: 52.62993, lng: 1.29676 }, { lat: 52.62991, lng: 1.29648 }, {
  lat: 52.62989,
  lng: 1.29637
}, { lat: 52.62983, lng: 1.2962 }, { lat: 52.6298, lng: 1.29612 }, { lat: 52.62977, lng: 1.29605 }, { lat: 52.62967, lng: 1.29592 }, { lat: 52.62962, lng: 1.29586 }, { lat: 52.62956, lng: 1.29574 }, {
  lat: 52.6295,
  lng: 1.29557
}, { lat: 52.62947, lng: 1.29545 }, { lat: 52.62941, lng: 1.29529 }, { lat: 52.62935, lng: 1.29515 }, { lat: 52.62928, lng: 1.29502 }, { lat: 52.62918, lng: 1.29486 }, { lat: 52.6291, lng: 1.2947 }, {
  lat: 52.62907,
  lng: 1.29417
}, { lat: 52.62906, lng: 1.2937 }, { lat: 52.62906, lng: 1.29339 }, { lat: 52.6289, lng: 1.29335 }, { lat: 52.62886, lng: 1.2933 }, { lat: 52.62884, lng: 1.29324 }, { lat: 52.62883, lng: 1.29314 }, {
  lat: 52.62887,
  lng: 1.29223
}, { lat: 52.62889, lng: 1.29212 }, { lat: 52.62894, lng: 1.29204 }, { lat: 52.62905, lng: 1.29193 }, { lat: 52.62907, lng: 1.29188 }, { lat: 52.62908, lng: 1.29183 }, { lat: 52.62909, lng: 1.29174 }, {
  lat: 52.62909,
  lng: 1.29161
}, { lat: 52.62908, lng: 1.29137 }, { lat: 52.62909, lng: 1.29116 }, { lat: 52.62911, lng: 1.29093 }, { lat: 52.62916, lng: 1.29059 }, { lat: 52.62925, lng: 1.28978 }, { lat: 52.62933, lng: 1.28907 }, {
  lat: 52.6294,
  lng: 1.28843
}, { lat: 52.62943, lng: 1.2882 }, { lat: 52.62943, lng: 1.28805 }, { lat: 52.62942, lng: 1.28796 }, { lat: 52.6294, lng: 1.28788 }, { lat: 52.62937, lng: 1.2878 }, { lat: 52.62926, lng: 1.28749 }, {
  lat: 52.62916,
  lng: 1.28721
}, { lat: 52.62908, lng: 1.28702 }, { lat: 52.62899, lng: 1.2868 }, { lat: 52.62891, lng: 1.28662 }, { lat: 52.62884, lng: 1.28647 }, { lat: 52.62877, lng: 1.28628 }, { lat: 52.62875, lng: 1.28629 }, {
  lat: 52.6286,
  lng: 1.28608
}, { lat: 52.62854, lng: 1.286 }, { lat: 52.62846, lng: 1.28586 }, { lat: 52.62855, lng: 1.28581 }, { lat: 52.62862, lng: 1.28571 }, { lat: 52.62865, lng: 1.28563 }, { lat: 52.62867, lng: 1.28551 }, {
  lat: 52.62868,
  lng: 1.28543
}, { lat: 52.62877, lng: 1.2854 }, { lat: 52.62884, lng: 1.28533 }, { lat: 52.62928, lng: 1.28524 }, { lat: 52.6297, lng: 1.28518 }, { lat: 52.63005, lng: 1.28512 }, { lat: 52.63038, lng: 1.28506 }, {
  lat: 52.63083,
  lng: 1.28498
}, { lat: 52.63102, lng: 1.28496 }, { lat: 52.63129, lng: 1.28499 }, { lat: 52.63159, lng: 1.28508 }, { lat: 52.63186, lng: 1.28526 }, { lat: 52.63246, lng: 1.28575 }, { lat: 52.63282, lng: 1.28604 }, {
  lat: 52.63308,
  lng: 1.28624
}, { lat: 52.63338, lng: 1.28646 }]

let riversideCoords = [{ lat: 52.62789, lng: 1.30588 }, { lat: 52.6278, lng: 1.30623 }, { lat: 52.62773, lng: 1.30641 }, { lat: 52.62761, lng: 1.30687 }, {
  lat: 52.62748,
  lng: 1.30732
}, { lat: 52.62739, lng: 1.30763 }, { lat: 52.62725, lng: 1.30828 }, { lat: 52.62724, lng: 1.30833 }, { lat: 52.62716, lng: 1.30826 }, { lat: 52.62709, lng: 1.30818 }, { lat: 52.62701, lng: 1.30811 }, {
  lat: 52.62694,
  lng: 1.30803
}, { lat: 52.62686, lng: 1.30796 }, { lat: 52.62682, lng: 1.30795 }, { lat: 52.62677, lng: 1.30795 }, { lat: 52.62671, lng: 1.30797 }, { lat: 52.62664, lng: 1.308 }, { lat: 52.62657, lng: 1.30806 }, {
  lat: 52.62652,
  lng: 1.30816
}, { lat: 52.62644, lng: 1.3084 }, { lat: 52.62633, lng: 1.30871 }, { lat: 52.62556, lng: 1.31083 }, { lat: 52.62533, lng: 1.31147 }, { lat: 52.62366, lng: 1.30998 }, { lat: 52.62356, lng: 1.30983 }, {
  lat: 52.62352,
  lng: 1.30975
}, { lat: 52.6233, lng: 1.31015 }, { lat: 52.62306, lng: 1.31056 }, { lat: 52.62284, lng: 1.311 }, { lat: 52.62277, lng: 1.31126 }, { lat: 52.62274, lng: 1.31153 }, { lat: 52.6224, lng: 1.31146 }, {
  lat: 52.62235,
  lng: 1.31141
}, { lat: 52.62228, lng: 1.31139 }, { lat: 52.62218, lng: 1.31129 }, { lat: 52.62204, lng: 1.31109 }, { lat: 52.62193, lng: 1.31101 }, { lat: 52.6217, lng: 1.31101 }, { lat: 52.62131, lng: 1.31106 }, {
  lat: 52.62094,
  lng: 1.31109
}, { lat: 52.62065, lng: 1.31103 }, { lat: 52.62012, lng: 1.31099 }, { lat: 52.62015, lng: 1.31088 }, { lat: 52.62021, lng: 1.3105 }, { lat: 52.62038, lng: 1.30969 }, { lat: 52.6206, lng: 1.30868 }, {
  lat: 52.62073,
  lng: 1.30818
}, { lat: 52.62087, lng: 1.30774 }, { lat: 52.62103, lng: 1.30725 }, { lat: 52.62119, lng: 1.3068 }, { lat: 52.6213, lng: 1.30661 }, { lat: 52.62145, lng: 1.30626 }, { lat: 52.62153, lng: 1.30613 }, {
  lat: 52.62162,
  lng: 1.30596
}, { lat: 52.62206, lng: 1.30534 }, { lat: 52.62229, lng: 1.30504 }, { lat: 52.62236, lng: 1.30495 }, { lat: 52.62249, lng: 1.30483 }, { lat: 52.62251, lng: 1.30474 }, { lat: 52.62276, lng: 1.30451 }, {
  lat: 52.62282,
  lng: 1.30452
}, { lat: 52.62287, lng: 1.30448 }, { lat: 52.62318, lng: 1.30426 }, { lat: 52.62345, lng: 1.30416 }, { lat: 52.62384, lng: 1.30403 }, { lat: 52.62427, lng: 1.30387 }, { lat: 52.6247, lng: 1.30367 }, {
  lat: 52.62484,
  lng: 1.30361
}, { lat: 52.62501, lng: 1.30353 }, { lat: 52.62526, lng: 1.3034 }, { lat: 52.6254, lng: 1.30337 }, { lat: 52.62546, lng: 1.30334 }, { lat: 52.62557, lng: 1.30334 }, { lat: 52.6257, lng: 1.30335 }, {
  lat: 52.62574,
  lng: 1.30345
}, { lat: 52.62585, lng: 1.3035 }, { lat: 52.62599, lng: 1.30361 }, { lat: 52.6261, lng: 1.30372 }, { lat: 52.62616, lng: 1.30367 }, { lat: 52.62619, lng: 1.30373 }, { lat: 52.62625, lng: 1.30382 }, {
  lat: 52.62638,
  lng: 1.30409
}, { lat: 52.62662, lng: 1.30457 }, { lat: 52.62665, lng: 1.3046 }, { lat: 52.62684, lng: 1.30489 }, { lat: 52.62692, lng: 1.30501 }, { lat: 52.62708, lng: 1.3052 }, { lat: 52.62717, lng: 1.30531 }, {
  lat: 52.62724,
  lng: 1.30539
}, { lat: 52.62735, lng: 1.30546 }, { lat: 52.62739, lng: 1.30551 }, { lat: 52.62749, lng: 1.30561 }, { lat: 52.62758, lng: 1.30566 }, { lat: 52.62771, lng: 1.30574 }, { lat: 52.62778, lng: 1.30581 }]

module.exports = {
  businessCoords,
  chapelfieldCoords,
  kingsCoords,
  riversideCoords,
  cathedralCoords,
  creativeCoords,
  lanesCoords,
  castleCoords,
}
